import { useEffect, useState } from 'react'
import { config } from '../lib/config'
import { Button } from './Button'

export function PlayButton({ compact = false }: { compact?: boolean }) {
  const [feedback, setFeedback] = useState<'copied' | 'error' | null>(null)

  useEffect(() => {
    if (feedback === null) return
    const timer = window.setTimeout(() => setFeedback(null), 2200)
    return () => window.clearTimeout(timer)
  }, [feedback])

  async function copyServerIp() {
    try {
      await navigator.clipboard.writeText(config.serverIp)
      setFeedback('copied')
    } catch {
      setFeedback('error')
    }
  }

  return (
    <div className="play-action">
      <Button
        aria-describedby="copy-feedback"
        className={compact ? 'button--compact' : ''}
        onClick={() => void copyServerIp()}
        type="button"
      >
        {compact ? 'Gioca' : 'Gioca ora'} <span aria-hidden="true">↗</span>
      </Button>
      <span
        className={`copy-feedback ${feedback !== null ? 'copy-feedback--visible' : ''}`}
        id="copy-feedback"
        role="status"
      >
        {feedback === 'error'
          ? `Copia non riuscita. IP: ${config.serverIp}`
          : `IP copiato: ${config.serverIp}`}
      </span>
    </div>
  )
}
